// Initialize newsfeed functionality for both direct page loads and Turbo/AJAX loads
function initializeNewsfeed() {
  // Remove existing event handlers to prevent duplicates
  $(document).off("click", "#user_newsfeed_post");
  $(document).off("change", "#post_photo");

  // Use event delegation for dynamically loaded content
  $(document).on("click", "#user_newsfeed_post", function () {
    $("#post_photo").click();
  });

  function removeAttachedLink() {
    $("#link_previewer_photo").empty();
    $("#post_attached_url").val("");
    $("#link_previewer_desc").find("h6").text("");
    $("#link_previewer_desc").find("p").text("");
    $("#link_previewer").hide();
  }

  $(document).on("change", "#post_photo", function () {
    if (typeof FileReader != "undefined") {
      var image_holder = $("#photo_attach_placeholder");
      image_holder.empty();
      var reader = new FileReader();

      reader.onload = function (event) {
        $("<img />", {
          src: event.target.result,
        }).appendTo(image_holder);
      };

      reader.readAsDataURL($(this)[0].files[0]);
      removeAttachedLink();
    }
  });

  $(document).on(
    "click",
    "#user_newsfeed_report_modal_close_button",
    function () {
      $("#user_newsfeed_report_modal").fadeOut("slow");
    }
  );

  refreshCheckAttachedLink();

  function refreshCheckAttachedLink() {
    checkAttachedLink("#post_body");
  }

  function checkAttachedLink(field) {
    var web_url =
      /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
    var regex = new RegExp(web_url);
    var val = $(field).val() || "";
    var matches = val.match(regex);

    if (matches) {
      if (!matches[0].includes("http://") && !matches[0].includes("https://")) {
        var attached_link = "http://" + matches[0];
      } else {
        var attached_link = matches[0];
      }
    }

    if (
      $("#photo_attach_placeholder").find("img").length === 0 &&
      matches &&
      $("#post_attached_url").val() !== attached_link
    ) {
      document.body.style.cursor = "wait";

      $.ajax({
        method: "POST",
        url: "/newsfeed_ajax/post_link_preview",
        data: { url: attached_link },
        success: function (response) {
          if (response) {
            $("#link_previewer_photo").empty();
            $("#post_attached_url").val(response[0]);
            $('<img src="' + response[3] + '">').appendTo(
              "#link_previewer_photo"
            );
            $("#link_previewer_desc").find("h6").text(response[1]);
            $("#link_previewer_desc").find("p").text(response[2]);
            $("#link_previewer").closest("a").attr("href", response[0]);
            $("#link_previewer").show();
          } else {
            removeAttachedLink();
          }

          document.body.style.cursor = "default";
        },
      });

      setTimeout(refreshCheckAttachedLink, 10000);
    } else if (!matches && $("#post_attached_url").val() !== "") {
      removeAttachedLink();
      setTimeout(refreshCheckAttachedLink, 5000);
    } else {
      setTimeout(refreshCheckAttachedLink, 5000);
    }
  }

  function toggleAudience(field) {
    if ($(field).val() === "true") {
      $("#audience_fields").fadeIn();
    } else {
      $("#audience_fields").fadeOut();
    }
  }

  bindCommentButton(".user_newsfeed_comment");
  bindCommentEditButton(".post_comment_edit");
  bindNewsfeedOptions(".user_newsfeed_options"); //move back to index.js
  bindReportButton('.user_newsfeed_options_list[data-value="report"]');
  bindPinButton('.user_newsfeed_options_list[data-value="pin"]');
  bindBanButton('.user_newsfeed_options_list[data-value="ban"]');
  bindEditButton('.user_newsfeed_options_list[data-value="edit"]');
  bindDeleteButton('.user_newsfeed_options_list[data-value="delete"]');
  bindLikeButton(".user_newsfeed_like");
  bindSubmitEdit("#comment_edit_text");
  bindCommentDelete(".post_comment_delete");
  bindCommentReply(".post_comment_reply");
  bindCommentSubmit($('input[name="post_comment[content]"]'));

  function bindCommentButton(button) {
    $(button).off("click").on("click", function () {
      var id = $(this).attr("data-id");
      $('.user_newsfeed_comment_children[data-id="' + id + '"]').fadeToggle(
        "slow"
      );
    });
  }

  function bindCommentEditButton(button) {
    $(button).off("click").on("click", function () {
      var container = $(
        '.post_comment_content[data-id="' + $(this).attr("data-id") + '"]'
      );
      var editor = $("#comment_edit_container");

      if ($(container).css("display") === "none") {
        $(editor).hide();
        $(".post_comment_content").fadeIn();
      } else {
        $(".post_comment_content").fadeIn();
        $(container).hide();
        $("#comment_edit_id").val($(container).attr("data-id"));
        $("#comment_edit_text").val($(container).attr("data-comment"));
        $(editor).detach().appendTo($(container).closest("p"));
        $(editor).fadeIn();
      }
    });
  }

  function bindReportButton(button) {
    $(button).off("click").on("click", function () {
      $("#post_report_post_id").val($(this).attr("data-id"));
      $("#user_newsfeed_report_modal").fadeIn("slow");
    });
  }

  function bindEditButton(button) {
    $(button).off("click").on("click", function () {
      var postId = $(this).attr("data-id");
      var editUrl = $(this).attr("data-edit-url");
      
      if (typeof openEditModal === 'function') {
        openEditModal(postId, editUrl);
      } else {
        // Fallback to direct navigation if modal function not available
        window.location.href = editUrl;
      }
      
      // Close the options dropdown
      $(".user_newsfeed_options_child").hide();
    });
  }

  function bindPinButton(button) {
    $(button).off("click").on("click", function () {
      element = $(this);
      document.body.style.cursor = "wait";

      $.ajax({
        method: "POST",
        async: true,
        url: "/newsfeed_ajax/toggle_post_pin",
        data: { id: $(this).attr("data-id") },
        success: function (response) {
          if (response.response === "Pinned") {
            popupNotification("Pinned!");
            $('.newsfeed_pinned_tag[data-id="' + response.id + '"]').fadeIn(
              "slow"
            );
            element.html('<p class="m-0">Unpin</p>');
          } else if (response.response === "Unpinned") {
            $('.newsfeed_pinned_tag[data-id="' + response.id + '"]').fadeOut(
              "slow"
            );
            element.html('<p class="m-0">Pin</p>');
            popupNotification("Unpinned!");
          } else if (response.response === "Error") {
            popupNotification(
              "Cannot pin/unpin. You may have been signed out. Please try again."
            );
          }

          document.body.style.cursor = "default";
        },
      });
    });
  }

  function bindBanButton(button) {
    $(button).off("click").on("click", function () {
      document.body.style.cursor = "wait";

      $.ajax({
        method: "POST",
        async: true,
        url: "/newsfeed_ajax/toggle_post_ban",
        data: { id: $(this).attr("data-id") },
        success: function (response) {
          if (response.response === "Banned") {
            $('.newsfeed_postings[data-id="' + response.id + '"]').fadeOut();
            $('.newsfeed_banned_tag[data-id="' + response.id + '"]').fadeIn(
              "slow"
            );
            popupNotification("Removed");
          } else if (response.response === "Unbanned") {
            $('.newsfeed_banned_tag[data-id="' + response.id + '"]').fadeOut(
              "slow"
            );
            popupNotification("Unbanned");
          } else if (response.response === "Error") {
            popupNotification(
              "Cannot remove. You may have been signed out. Please try again."
            );
          }

          document.body.style.cursor = "default";
        },
      });
    });
  }

  function bindDeleteButton(button) {
    $(button).off("click").on("click", function () {
      var bool = confirm("Are you sure you want to delete this post?");

      if (bool) {
        document.body.style.cursor = "wait";

        $.ajax({
          method: "POST",
          async: true,
          url: "/newsfeed_ajax/post_delete",
          data: { id: $(this).attr("data-id") },
          success: function (response) {
            $('.newsfeed_postings[data-id="' + response + '"]').fadeOut();

            setTimeout(function () {
              $('.newsfeed_postings[data-id="' + response + '"]').remove();
            }, 1000);

            document.body.style.cursor = "default";
          },
        });
      }
    });
  }

  function bindLikeButton(button) {
    $(button).off("click").on("click", function () {
      var id = $(this).attr("data-id");
      document.body.style.cursor = "wait";

      $.ajax({
        method: "POST",
        async: true,
        url: "/newsfeed_ajax/toggle_post_like",
        data: { id: id },
        success: function (response) {
          var value = parseInt(
            $('.user_newsfeed_like_value[data-id="' + response.id + '"]').text()
          );
          if (response.response === "Liked") {
            $('.user_newsfeed_like_value[data-id="' + response.id + '"]').text(
              value + 1
            );
            $('.newsfeed_postings[data-id="' + response.id + '"]').attr(
              "data-liked",
              "Yes"
            );
            $('.newsfeed_like[data-id="' + response.id + '"]').css(
              "color",
              "red"
            );
          } else if (response.response === "Unliked") {
            $('.user_newsfeed_like_value[data-id="' + response.id + '"]').text(
              value - 1
            );
            $('.newsfeed_postings[data-id="' + response.id + '"]').attr(
              "data-liked",
              "No"
            );
            $('.newsfeed_like[data-id="' + response.id + '"]').css(
              "color",
              "black"
            );
          } else if (response.response === "Error") {
            popupNotification(
              "Cannot like/unlike. You may have been signed out. Please try again."
            );
          }

          document.body.style.cursor = "default";
        },
      });
    });
  }

  function bindSubmitEdit(field) {
    $(field).off("keydown").on("keydown", function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        document.body.style.cursor = "wait";
        var edit = $("#comment_edit_text").val();
        var id = $("#comment_edit_id").val();
        var container = $('.post_comment_content[data-id="' + id + '"]');
        var editor = $("#comment_edit_container");

        if ($(container).attr("data-comment") !== edit && edit !== "") {
          $.ajax({
            method: "POST",
            async: true,
            url: "/newsfeed_ajax/post_comment_edit",
            data: { id: id, edit: edit },
            success: function (response) {
              var appending = $(response).find("#comment_response");
              $(container).attr(
                "data-comment",
                $(appending).attr("data-comment")
              );
              $(container).html($(appending).html());
              document.body.style.cursor = "default";
            },
          });
        }

        $(editor).hide();
        $(container).fadeIn();
      }
    });
  }

  function bindCommentDelete(button) {
    $(button).off("click").on("click", function () {
      var confirmation = confirm("Delete this comment?");

      if (confirmation) {
        document.body.style.cursor = "wait";

        $.ajax({
          method: "POST",
          async: true,
          url: "/newsfeed_ajax/post_comment_delete",
          data: { id: $(this).attr("data-id"), post: $(this).attr("post-id") },
          success: function (response) {
            $(
              '.post_comment_item[data-id="' + response.comment + '"]'
            ).fadeOut();
            $('.user_newsfeed_comment[data-id="' + response.post + '"]').text(
              " " +
                (parseInt(
                  $(
                    '.user_newsfeed_comment[data-id="' + response.post + '"]'
                  ).text()
                ) -
                  1) +
                " Comments"
            );
            document.body.style.cursor = "default";
          },
        });
      }
    });
  }

  function bindCommentReply(button) {
    $(button).off("click").on("click", function () {
      $("div.replying_placeholder").remove();
      var comment = $(this).attr("data-id");
      var clone = $(
        '.user_newsfeed_comment_children[data-id="' +
          $(this).attr("data-post") +
          '"]'
      )
        .closest(".newsfeed_comment")
        .find("form.new_post_comment")
        .clone();
      clone.find("input#post_comment_reply").val(comment);
      var reply = $('<div class="replying_placeholder"></div>').append(clone);
      bindCommentSubmit($(clone).find('input[name="post_comment[content]"]'));
      $(reply).insertAfter($(this).closest(".user_newsfeed_comment_content"));
    });
  }

  function bindCommentSubmit(field) {
    $(field).off("keydown").on("keydown", function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();

        if ($.trim($(this).val()) != "") {
          document.body.style.cursor = "wait";
          var hash = "{";

          $(this)
            .closest("form")
            .find('input[name*="post_comment"]')
            .each(function (index) {
              if (index > 0) {
                hash += ",";
              }
              hash += '"' + $(this).attr("name") + '": "' + $(this).val() + '"';
            });

          params = JSON.parse(hash + "}");
          $(this).val("");

          $.ajax({
            method: "POST",
            async: true,
            url: "/newsfeed_ajax/post_comment_create",
            data: params,
            success: function (response) {
              if (response.error) {
                if (response.message) {
                  popupAlert(response.message);
                } else {
                  popupAlert(
                    "There was an error creating your comment. You may have been signed out. Please sign in again to comment."
                  );
                }
                document.body.style.cursor = "default";
              } else {
                var id = $(response)
                  .find(".post_comment_delete")
                  .attr("post-id");
                var clone = $(response).find(".post_comment_item");
                bindCommentEditButton(
                  $(clone).find(".post_comment_edit")
                );
                bindCommentDelete($(clone).find(".post_comment_delete"));
                bindCommentReply($(clone).find(".post_comment_reply"));
                $(
                  '.user_newsfeed_comment_children[data-id="' + id + '"]'
                ).append(clone);
                rearrangeCommentReplies(
                  '.post_comment_item[data-reply="true"][data-placed="false"]'
                );
                $('.user_newsfeed_comment[data-id="' + id + '"]').text(
                  " " +
                    (parseInt(
                      $(
                        '.user_newsfeed_comment[data-id="' + id + '"]'
                      ).text()
                    ) +
                      1) +
                    " Comments"
                );
                document.body.style.cursor = "default";
                $("div.replying_placeholder").remove();

                $("html, body").animate({
                  scrollTop:
                    $(clone).offset().top - $(window).height() * 0.4,
                });
              }
            },
          });
        }
      }
    });
  }

  function rearrangeCommentReplies(comment) {
    $(comment).each(function (index) {
      var id = $(this).attr("data-reply-id");

      if (
        $(
          '.post_comment_item[data-reply="true"][data-placed="true"][data-reply-id="' +
            id +
            '"]'
        ).length > 0
      ) {
        $(this)
          .attr("data-placed", "true")
          .detach()
          .insertAfter(
            $(
              '.post_comment_item[data-reply="true"][data-placed="true"][data-reply-id="' +
                id +
                '"]'
            ).last()
          );
      } else {
        $(this)
          .attr("data-placed", "true")
          .detach()
          .insertAfter($('.post_comment_item[data-id="' + id + '"]'));
      }
    });
  }

  function loadNewsfeedPostLink(id) {
    $.ajax({
      method: "GET",
      url: "/ajax/get_post_link",
      data: { id: id },
      success: function (response) {
        $(
          '.post_link_placeholder[data-id="' +
            $(response).attr("data-id") +
            '"]'
        ).replaceWith($(response));
      },
    });
  }

  $(".post_link_placeholder").each(function (index, div) {
    loadNewsfeedPostLink($(div).attr("data-id"));
  });

  // For Mobile Scroll. (Note: If Testing using inspector tool, scroll screen with mouse left click instead of using mouse wheel.)
  // $('body').on('touchmove', function(){
  // 	if (document.body.scrollTop >= $(document).height() - $(window).height() - 1000) {
  // 		loadNewsfeedContent();
  // 	}
  // });

  // // Desktop Scroll.
  // $(window, 'body').scroll(function() {
  // 	if ($(window).scrollTop() >= $(document).height() - $(window).height() - 1000) {
  // 		console.log('true');
  // 		loadNewsfeedContent();
  // 	}
  // });

  function loadNewsfeedContent() {
    if ($("data#loading-newsfeed-content").length < 1) {
      $("body").append('<data id="loading-newsfeed-content"></data>');

      if ($("#newsfeed_post_ids").text().length > 0) {
        document.body.style.cursor = "wait";

        $.ajax({
          method: "POST",
          async: true,
          url: "/newsfeed_ajax/load_newsfeed_content",
          data: {
            ids: $("#newsfeed_post_ids").text(),
            last_id: $(".newsfeed_postings").last().attr("data-id"),
            redirect_url: $("#redirect_url").val(),
          },
          success: function (response) {
            var clone = $(response).find(".newsfeed_postings");

            if (clone.length > 0) {
              bindCommentButton($(clone).find(".user_newsfeed_comment"));
              bindCommentEditButton($(clone).find(".post_comment_edit"));
              bindNewsfeedOptions($(clone).find(".user_newsfeed_options"));
              bindReportButton(
                $(clone).find(
                  '.user_newsfeed_options_list[data-value="report"]'
                )
              );
              bindPinButton(
                $(clone).find('.user_newsfeed_options_list[data-value="pin"]')
              );
              bindBanButton(
                $(clone).find('.user_newsfeed_options_list[data-value="ban"]')
              );
              bindEditButton(
                $(clone).find('.user_newsfeed_options_list[data-value="edit"]')
              );
              bindDeleteButton(
                $(clone).find(
                  '.user_newsfeed_options_list[data-value="delete"]'
                )
              );
              bindLikeButton($(clone).find(".user_newsfeed_like"));
              bindSubmitEdit($(clone).find("#comment_edit_text"));
              bindCommentDelete($(clone).find(".post_comment_delete"));
              bindCommentReply($(clone).find(".post_comment_reply"));
              bindCommentSubmit(
                $(clone).find('input[name="post_comment[content]"]')
              );
              clone.insertAfter($(".newsfeed_postings").last());
              $("#loading-newsfeed-content").remove();

              $(clone)
                .find(".post_link_placeholder")
                .each(function (index) {
                  var container = $(this);

                  $.ajax({
                    method: "GET",
                    async: true,
                    url: "/ajax/get_post_link",
                    data: { id: container.attr("data-id") },

                    success: function (response) {
                      var cont = $(response);
                      $(
                        '.post_link_placeholder[data-id="' +
                          cont.attr("data-id") +
                          '"]'
                      ).replaceWith(cont);
                    },
                  });
                });
            }

            document.body.style.cursor = "default";
          },
        });
      }
    }
  }

  function bindNewsfeedOptions(button) {
    //move back to index.js
    // Skip if inline handlers are active
    if (window.newsfeedOptionsInlineHandlers) {
      return;
    }
    
    $(button).off("click").on("click", function () {
      child = $(
        '.user_newsfeed_options_child[data-id="' +
          $(this).attr("data-id") +
          '"]'
      );
      to_show = child.css("display") === "none";
      $(".user_newsfeed_options_child").hide();

      if (to_show) {
        child.show();
      } else {
        child.hide();
      }
    });
  }

  $(document).on(
    "click",
    ".user_newsfeed_options, .user_newsfeed_options_child",
    function (event) {
      event.stopPropagation();
      let container = $(".user_newsfeed_options, .user_newsfeed_options_child");

      if (
        container.has(event.target).length === 0 &&
        !container.get().includes(event.target)
      ) {
        $(".user_newsfeed_options_child").hide();
        $(".user_newsfeed_options_child").find("i.fas").show();
      }
    }
  );

  $(document).on("keydown", function (event) {
    if (event.keyCode === 27) {
      // ESC
      $(".user_newsfeed_options_child").hide();
    }
  });
}

// Make the function globally available
window.initializeNewsfeed = initializeNewsfeed;

// Track if already initialized to prevent multiple initializations on same page
window.newsfeedInitialized = false;


// Initialize on document ready - using jQuery shorthand
$(function () {
  // Only auto-initialize if not already initialized by the ERB template
  setTimeout(function() {
    if (!window.newsfeed_initialized && !window.newsfeedInitialized) {
      initializeNewsfeed();
      window.newsfeedInitialized = true;
    } else {
      console.log("Newsfeed already initialized, skipping");
    }
  }, 100);
});

// Initialize for Turbo navigation
$(document).on("turbo:load", function () {
  initializeNewsfeed();
});

// Initialize for Turbo Frame navigation
$(document).on("turbo:frame-load", function () {
  initializeNewsfeed();
});
